import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface IconButtonProps {
  readonly children: ReactNode;
  readonly variant?: "default" | "ghost" | "square-small";
  readonly onClick?: () => void;
  readonly label?: string;
}

const variantStyles: Readonly<Record<NonNullable<IconButtonProps["variant"]>, string>> = {
  default: "w-[30px] h-[30px] rounded-sm border border-edge hover:border-edge-strong hover:bg-surface-hover hover:text-content",
  ghost: "w-[30px] h-[30px] rounded-sm border border-transparent hover:bg-surface-hover hover:text-content",
  "square-small": "w-6 h-6 rounded-[7px] border border-edge hover:border-edge-strong hover:bg-surface-hover hover:text-content",
};

export function IconButton({
  children,
  variant = "default",
  onClick,
  label,
}: IconButtonProps): JSX.Element {
  return (
    <button
      className={cn(
        "bg-transparent text-content-secondary inline-flex items-center justify-center cursor-pointer",
        "transition-all duration-[180ms] ease-out",
        // Tailwind v4: outline-<n> sets only the width — without
        // `outline-solid` the ring never paints (outline-style stays none).
        "focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-accent/70 focus-visible:outline-offset-2",
        variantStyles[variant],
      )}
      onClick={onClick}
      aria-label={label}
      type="button"
    >
      {children}
    </button>
  );
}
